// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P2-dA","importantInfo":"styles_importantInfo__23sVV"};